function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 20.5,
  cy: 20,
  r: 20,
  fill: "#FDCE00"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.15,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.367 27.8l11.866 11.866c8.667-1.466 15.534-8.333 17-17L28.3 10.8l-16.933 17z",
  fill: "#000"
});
var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 21.167,
  cy: 20.667,
  r: 12,
  fill: "#FDCE00"
});
var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 21.167,
  cy: 20.667,
  r: 10.667,
  fill: "#fff"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.967 23.533L21.833 20.4V14c0-.4-.266-.667-.666-.667S20.5 13.6 20.5 14v6.666c0 .2.067.334.2.467l3.333 3.333c.134.134.267.2.467.2.4 0 .667-.266.667-.666 0-.2-.067-.334-.2-.467z",
  fill: "#FDCE00"
});
function SvgCourseAdminTabFuture(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 41 40",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
}
export default __webpack_public_path__ + "fonts/course-admin-tab-future-8d0eca5484d515e8a36e840311ecb9c1.svg";
export { SvgCourseAdminTabFuture as ReactComponent };